export function stripRawI18nKeys(label: string): string {
  const cleaned = label.replace(/\s*\b[a-z][a-z0-9]*\.[a-z0-9_]*_suffix\b/gi, '').trim();
  return cleaned || label;
}

export function actorName(
  raw: string | null | undefined,
  order: 'first-last' | 'last-first',
): string | null {
  const label = stripRawI18nKeys((raw ?? '').trim());
  if (!label) return null;
  const parts = label.split(/\s+/).filter(Boolean);
  if (parts.length !== 2) return label;
  const [a = '', b = ''] = parts;
  const [first, last] = order === 'first-last' ? [a, b] : [b, a];
  return `${first} ${last.charAt(0).toUpperCase()}.`;
}

export function initialsOf(name: string | null | undefined): string {
  const parts = (name ?? '').replace(/\./g, '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';
  if (parts.length === 1) return (parts[0] ?? '').slice(0, 2).toUpperCase();
  return `${(parts[0] ?? '').charAt(0)}${(parts[1] ?? '').charAt(0)}`.toUpperCase();
}

export function bidiIsolate(text: string, rtl: boolean): string {
  return rtl ? `\u2068${text}\u2069` : text;
}
